var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    d: "M15 18.772c1.856 0 3.892.27 6.108.809 2.515.629 4.55 1.467 6.108 2.515C29.072 23.323 30 24.7 30 26.228V30H0v-3.772c0-1.527.928-2.905 2.784-4.132 1.557-1.048 3.593-1.886 6.108-2.515 2.216-.54 4.252-.809 6.108-.809zM15 15c-1.347 0-2.59-.337-3.728-1.01-1.137-.674-2.043-1.58-2.717-2.718-.673-1.137-1.01-2.38-1.01-3.727s.337-2.605 1.01-3.773c.674-1.167 1.58-2.088 2.717-2.762C12.41.337 13.652 0 15 0c1.347 0 2.59.337 3.728 1.01 1.137.674 2.043 1.595 2.717 2.762.673 1.168 1.01 2.426 1.01 3.773s-.337 2.59-1.01 3.727c-.674 1.138-1.58 2.044-2.717 2.718C17.59 14.663 16.348 15 15 15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeGreen);
export default __webpack_public_path__ + "static/media/me_green.c3f833de61711271978edfdba9baa7bc.svg";
export { ForwardRef as ReactComponent };